<template>
  <v-card>
    <v-toolbar card dense dark color="primary">
      <v-toolbar-title class="white--text">{{$t('servicios.eliminarServicio')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-actions class="justify-center">{{$t('servicios.eliminarServicioPregunta')}}</v-card-actions>
    <v-card-actions>
      <v-btn block flat class="secondary" @click="cancelar">{{$t('otros.no')}}</v-btn>
      <v-btn block flat class="primary" @click="aceptar">{{$t('otros.si')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ConfirmacionModal",
  data() {
    return {};
  },
  methods: {
    aceptar() {
      this.$emit("aceptar");
    },
    cancelar() {
      this.$emit("cancelar");
    }
  }
};
</script>
